import React from 'react';
import '../css/styleguide.css';
import { Link } from 'react-router-dom';
import PrimaryButton from './PrimaryButton';

const Book1 = () => {
  return (
    <section className='book-wrapper'>
      <div className='book-card'>
        <div className='book-card__content'>
          <div className='book-card__meta'>
            <p className='book-card__eyebrow'>Featured novel</p>
            <h3>The Young Samaritan</h3>
            <p className='book-card__author'>by J. Schuyler Sprowles</p>
          </div>
          <p className='book-card__summary'>
            Inspired by a passage from the Gospel of Mark, this coming-of-age
            novel follows Joshua, a Samaritan boy forced to flee home and make
            his way through a world that is as brutal as it is beautiful. Along
            the way he encounters uncommon grace, haunting visions, and the
            people who slowly reshape his understanding of faith, love, and
            belonging.
          </p>
          <div className='book-card__highlights'>
            <div className='book-card__highlight'>
              <span className='book-card__highlight-label'>Genre</span>
              <span>Historical faith-based fiction</span>
            </div>
            <div className='book-card__highlight'>
              <span className='book-card__highlight-label'>Perspective</span>
              <span>A young Samaritan coming of age in biblical times</span>
            </div>
          </div>
          <div className='book-card__actions'>
            <PrimaryButton
              as={Link}
              to='/writing/the-young-samaritan'
              label='Explore the book'
            />
            <PrimaryButton
              as={Link}
              to='/writing/the-young-samaritan/reviews'
              label='Read reviews'
              tone='light'
            />
          </div>
        </div>
        <div className='book-card__media'>
          <div className='book-card__cover-frame'>
            <Link className='link-plain' to='/writing/the-young-samaritan'>
              <img
                className='book-card__cover'
                src={process.env.PUBLIC_URL + '/images/book1.png'}
                alt='Cover of The Young Samaritan'
              />
            </Link>
          </div>
          <p className='book-card__note'>
            Follow Joshua&apos;s journey through fear, exile, and the first
            glimmers of faith.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Book1;
